import React from 'react';
import classnames from 'classnames';
import { Input } from 'reactstrap';
import './MainSelect.scss';

type Props = {
  children: any;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  valid?: boolean;
  invalid?: boolean;
  innerRef?: React.Ref<HTMLInputElement>;
  value: any;
  name?: string;
  disabled?: boolean;
};

const MainSelect = ({ children, className = '', ...props }: Props) => (
  <Input
    type="select"
    bsSize="lg"
    className={classnames('main-select', className)}
    {...props}
  >
    {children}
  </Input>
);

export default MainSelect;
